import { BackendModel, BackendService } from '../core/backend.service';
import { TipoConfiguracion } from './tipoConfiguracion.model';

export class Configuracion extends BackendModel {

  static path = '/configuracion/';

  id: number;
  valor: string;
  tipoConfiguracion: TipoConfiguracion;
  created: Date;
  updated: Date;
  deleted: Date;

  constructor(protected backendService: BackendService, model?: Configuracion) {
    super(backendService, model);
  }

}



// WEBPACK FOOTER //
// ./src/app/configuracion/configuracion.model.ts